
// Environment-aware configuration
// Values are injected at build time via webpack environment files

const signalRHubUrl = process.env.VUE_APP_SIGNALR_HUB_URL || 'http://localhost:8989/signalr'

const msLogin = {
  clientId: process.env.VUE_APP_MS_CLIENT_ID || '1bbd0edf-9305-4801-a6f6-b224ea17e84c',
  authority: process.env.VUE_APP_MS_AUTHORITY || 'https://login.microsoftonline.com/e0b2a496-c186-4e92-b4b0-7d466b05d8d9',
  redirectUri: process.env.VUE_APP_MS_REDIRECT_URI || 'http://localhost:8989/Office365AuthResponse/',
}

export default {
  signalRHubUrl,
  msLogin,
}